"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActiveChannels = void 0;
function createActiveChannels(channels) {
    const allChannels = ["email", "push", "whatsapp"];
    return allChannels.reduce((acc, channel) => ({ ...acc, [channel]: channels.includes(channel) }), { email: false, push: false, whatsapp: false });
}
exports.createActiveChannels = createActiveChannels;
